export const SYSTEM_MODULES = [
  { id: "home", name: "דף הבית" },
  { id: "products_admin", name: "מוצרים (ניהול קטלוג)" },
  { id: "store_products", name: "מוצרים (סניף)" },
  { id: "product_search", name: "חיפוש מוצרים" },
  { id: "inventory_manage", name: "ניהול ספירות מלאי (אדמין)" },
  { id: "slow_moving", name: "מוצרים ללא תנועה" },
  { id: "all_slow_moving", name: "מוצרים ללא תנועה (כלל רשתי)" },
  { id: "categories", name: "קטגוריות" },
  { id: "companies", name: "חברות" },
  { id: "suppliers", name: "ספקים" },
  { id: "chains", name: "ניהול רשתות" },
  { id: "stores", name: "ניהול סניפים" },
  { id: "promotions", name: "מבצעים" },
  { id: "recommendations", name: "המלצות הזמנה" },
  { id: "must_order", name: "חובת הזמנה" },
  { id: "new_products", name: "מוצרים חדשים" },
  { id: "service_requests", name: "קריאות שירות" },
  { id: "inventory_count", name: "ספירת מלאי" },
  { id: "notifications", name: "הודעות" },
  { id: "destructions", name: "השמדות" },
  { id: "returns", name: "חזרות" },
  { id: "cart", name: "עגלת קניות" },
  { id: "invoice_scan", name: "סריקת חשבונית" },
  { id: "distributions", name: "חלוקות" },
  { id: "orders", name: "רשימת הזמנות" },
  { id: "brochures", name: "ברושורים" },
  { id: "promotion_impl", name: "הטמעת מבצעים" },
  { id: "safe_count", name: "ספירת כספות" },
  { id: "tasks", name: "משימות הנהלה" },
  { id: "users", name: "ניהול משתמשים" },
  { id: "system_settings", name: "הגדרות מערכת" },
];

export const RESTRICTED_MODULES = [
  "orders",
  "products_admin",
  "companies",
  "suppliers",
  "promotions",
];

export const MODULE_ACCESS_LEVELS = [
  { value: "none", label: "⛔ ללא גישה" },
  { value: "view", label: "👁️ צפייה בלבד" },
  { value: "edit", label: "✏️ עריכה מלאה" },
];

export const ROLE_MODULE_PERMISSIONS_SETTING_KEY = "role_module_permissions";

const DEFAULT_MODULE_LANDING_PAGES = [
  ["home", "Home"],
  ["safe_count", (user) => (isSystemAdminLevelUser(user) ? "SafeCountAdmin" : "SafeCount")],
  ["store_products", "StoreProducts"],
  ["product_search", "ProductSearch"],
  ["cart", "Cart"],
  ["inventory_count", "InventoryCount"],
  ["recommendations", "Recommendations"],
  ["must_order", "MustOrder"],
  ["promotions", "Promotions"],
  ["brochures", "Brochures"],
  ["promotion_impl", "PromotionImplementation"],
  ["orders", "Orders"],
  ["suppliers", "Suppliers"],
  ["companies", "Companies"],
  ["categories", "Categories"],
  ["stores", "Stores"],
  ["chains", "Chains"],
  ["notifications", "Notifications"],
  ["service_requests", "ServiceRequests"],
  ["destructions", "Destructions"],
  ["returns", "Returns"],
  ["tasks", "StoreManagementTasks"],
  ["users", "Users"],
  ["system_settings", "SystemSettings"],
];

export function isSystemAdminLevelUser(user) {
  const roleKey = user?.role?.key || user?.role;
  return (
    user?.isSuperAdmin === true ||
    roleKey === "SUPER_ADMIN" ||
    roleKey === "SYSTEM_ADMIN" ||
    roleKey === "admin" ||
    user?.custom_role === "system_admin"
  );
}

export function hasModuleAccess(user, moduleId) {
  if (user?.isSuperAdmin) return true;
  const access = user?.modules_access?.[moduleId];
  return access === "view" || access === "edit";
}

export function hasModuleEditAccess(user, moduleId) {
  if (user?.isSuperAdmin) return true;
  return user?.modules_access?.[moduleId] === "edit";
}

/** מנהל מערכת ספציפי שסומן לבצע ספירת כספת לסניפים (גם מחוץ לחלון) */
export function canPerformSafeCountForStores(user) {
  return isSystemAdminLevelUser(user) && !!user?.canPerformSafeCount;
}

/** מנהל אזור / מנהל מערכת מורשה — ביצוע ספירה לסניפים בניהולם */
export function canPerformSafeCountForManagedStores(user) {
  return canPerformSafeCountForStores(user) || isAreaManagerLevelUser(user);
}

export function isAreaManagerLevelUser(user) {
  const roleKey = user?.role?.key || user?.role;
  const custom = String(user?.custom_role ?? "").trim();
  return (
    roleKey === "AREA_MANAGER" ||
    custom === "area_manager" ||
    custom === "AREA_MANAGER"
  );
}

/** הזמנה מתחת למינימום — רק אם סומן בהגדרות המשתמש */
export function canBypassMinimumOrder(user) {
  return (
    !!user?.canBypassMinimumOrder &&
    (isAreaManagerLevelUser(user) || isSystemAdminLevelUser(user))
  );
}

export function getFirstAccessiblePage(user, fallbackPage = "Home") {
  const landing = DEFAULT_MODULE_LANDING_PAGES.find(([moduleId]) =>
    hasModuleAccess(user, moduleId)
  );
  const page = landing?.[1];
  return typeof page === "function" ? page(user) : page || fallbackPage;
}
